<script setup lang="ts">
import { computed } from 'vue'
import { T } from '@tolgee/vue'
import { useWatchOverlays } from '@/composables/helpers/scoll'

const props = defineProps<{
  show: boolean
}>()

useWatchOverlays(computed(() => props.show))
</script>

<template>
  <div
    class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 transition-all duration-300 bg-dark-primary bg-black flex flex-col"
  >
    <div class="h-full w-full bg-dark-most-bottom-layer/[.95] flex-1 flex flex-col">
      <div class="p-8 h-[85%] w-full mt-auto flex flex-col items-center justify-between">
        <div class="w-full items-center flex flex-col flex-1">
          <div class="max-[390px]:text-[70px] text-[80px] leading-6 font-semibold whitespace-nowrap">
            <T
              key-name="daily.all_done.title"
              default-value="Good job!"
            />
          </div>
          <div class="-mt-[76px] w-[366px] min-w-[366px] h-[366px] relative">
            <div class="absolute w-[80%] h-[80%] top-[10%] left-[10%] rounded-full bg-white/[.74] blur-[63px]" />
            <img
              class="w-[212px] min-w-[212px] h-[212px] object-cover absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2"
              src="@/assets/images/gifs/duck-thumb.gif"
            >
          </div>
          <div class="-mt-8 text-lg leading-6 text-center font-semibold max-w-[377px] min-[420px]:whitespace-pre-line">
            <T
              key-name="daily.all_done.text"
              :default-value="`You’ve completed all your goals for today!\n Keep going—big achievements await.\n You’ve got this!`"
            />
          </div>
          <div class="w-full invisible h-[64px]" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.bg-outer {
  background: url('@/assets/images/code.png') lightgray 50% / cover no-repeat;
}

.shadow-image {
  box-shadow: 0px 4px 4px 0px rgba(255, 255, 255, 0.40) inset;
}
</style>
